<div id="app-spinner" class="app-spinner" [style.display]="display">
  <mat-spinner color="accent"></mat-spinner>
</div>